import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import { teamsTabs } from '@shared/services/EnvironmentVariables';
import { WhereaboutsScope } from '@features/whereabouts/models/whereaboutsScope';
import WhereaboutsPageV2 from './WhereaboutsPageV2';
import { WhereaboutsBackLink } from './WhereaboutsScopeContext';

// Route components that render the shared whereabouts page pinned to one
// team or workgroup taken from the URL.

const COMPANY_TEAMS_BACK_LINK: WhereaboutsBackLink = {
  url: '/whereabouts/company/all',
  text: 'back-to-company-view',
  teamsTab: teamsTabs.company,
};

const COMPANY_WORKGROUPS_BACK_LINK: WhereaboutsBackLink = {
  url: '/whereabouts/company/workgroups',
  text: 'back-to-company-view',
  teamsTab: teamsTabs.company,
};

const TEAM_VIEW_BACK_LINK: WhereaboutsBackLink = {
  url: '/whereabouts/team',
  text: 'button.back-to-team-view',
  teamsTab: teamsTabs.team,
};

function useTeamScope(): WhereaboutsScope {
  const { teamId } = useParams<{ teamId: string }>();
  return useMemo<WhereaboutsScope>(() => ({ kind: 'team', teamId }), [teamId]);
}

// /whereabouts/company/team/:teamId and /whereabouts/team/:teamId
export function TeamWhereaboutsPage() {
  const scope = useTeamScope();
  return <WhereaboutsPageV2 scope={scope} backLink={COMPANY_TEAMS_BACK_LINK} />;
}

// /whereabouts/team/search/:teamId — the team of the person picked from the
// header search.
export function TeamSearchWhereaboutsPage() {
  const scope = useTeamScope();
  return <WhereaboutsPageV2 scope={scope} backLink={TEAM_VIEW_BACK_LINK} />;
}

// /whereabouts/company/tag/:tagId and /whereabouts/tag/:tagId
export function WorkgroupWhereaboutsPage() {
  const { tagId } = useParams<{ tagId: string }>();
  const scope = useMemo<WhereaboutsScope>(() => ({ kind: 'workgroup', workGroupId: Number(tagId) }), [tagId]);
  return <WhereaboutsPageV2 scope={scope} backLink={COMPANY_WORKGROUPS_BACK_LINK} />;
}
